/**
 * Converte uma string para Title Case (Apenas a primeira letra de cada palavra maiúscula).
 * Mantém conectores comuns em minúsculo (de, da, do, etc).
 */
export const toTitleCase = (str) => {
  if (!str) return '';
  return str
    .trim()
    .toLowerCase()
    .split(/\s+/)
    .map((word, index) => {
      if (word.length === 0) return '';
      
      // Conectores comuns que geralmente ficam em minúsculo em nomes
      const conectores = ['de', 'da', 'do', 'das', 'dos', 'e'];
      
      // Se for conector e não for a primeira palavra, mantém minúsculo
      if (conectores.includes(word) && index !== 0) {
        return word;
      }
      
      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join(' ');
};
